import { CheckboxField } from '@/components/ui'
import { PROJECT_TASK_STATUSES, type ProjectTask } from '@/modules/projects'
import { cn } from '@/utils'

interface TaskRowProps {
  task: ProjectTask
  onToggle: (task: ProjectTask) => void
}

export const TaskRow = ({ task, onToggle }: TaskRowProps) => {
  const done = task.status === PROJECT_TASK_STATUSES.done

  return (
    <CheckboxField
      id={`task-${task.id}`}
      checked={done}
      onCheckedChange={() => onToggle(task)}
      className="rounded-md p-2 hover:bg-muted/40"
      label={
        <span className="space-y-0.5">
          <span
            className={cn(
              'block font-medium text-foreground text-sm',
              done && 'text-muted-foreground line-through',
            )}
          >
            {task.title}
          </span>
          {task.detail && (
            <span className="block text-muted-foreground text-xs">
              {task.detail}
            </span>
          )}
          {task.dueHint && (
            <span className="block text-amber-600 text-xs">{task.dueHint}</span>
          )}
        </span>
      }
    />
  )
}
